// plugins/click-outside.js
import vClickOutside from 'click-outside-vue3'
import { defineNuxtPlugin } from 'nuxt/app'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('click-outside', vClickOutside.directive)
})
